import { isString } from './typeguards/isString'

export const getDELocaleFormatted = (val: number): string =>
  val.toLocaleString('de-DE')

export const getFormattedValueWithThousandSeparator = (
  value: number | string
): string => {
  if (isString(value)) {
    if (isNaN(parseInt(value))) {
      return value
    }
    return getDELocaleFormatted(parseInt(value))
  }
  return getDELocaleFormatted(value)
}
